import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js'
import React, { ReactElement } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Grid, Text } from '../../components/layout'
import { IStore } from '../../interfaces/store.interfaces'
import { chartColors, colors } from '../../theme.styles'

const PackageValuesChart = (): ReactElement => {
  ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
  const { t } = useTranslation()
  const statistics = useSelector((state: IStore) => state.statistics)
  const packageNames = statistics?.packageChart?.map(({ surface, categoryTitle }) => `${t(surface)} ${categoryTitle}`)
  const packageValues = statistics?.packageChart?.map(({ value }) => value?.toFixed(1))

  const data = {
    labels: packageNames,
    datasets: [
      {
        label: 'Package Chart',
        data: packageValues || [0],
        backgroundColor: chartColors,
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  }
  return (
    <Grid>
      <Text $weight={500} $textColor={colors.grey} $lineHeight="1">
        {t('PACKAGE_CHART')}
      </Text>
      <Doughnut options={options} data={data} />
    </Grid>
  )
}

export default PackageValuesChart
